import * as React from 'react';

function SvgTotalWinning(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={35} height={35} {...props}>
      <defs>
        <style>
          {
            '.total_winning_svg__prefix__cls-2{fill:#ff9a14}.total_winning_svg__prefix__cls-4{fill:#ac7121}.total_winning_svg__prefix__cls-5{fill:#24202b}.total_winning_svg__prefix__cls-9{fill:#dbb705}.total_winning_svg__prefix__cls-11{fill:#f19d69}'
          }
        </style>
      </defs>
      <g id="total_winning_svg__prefix__total_winning" transform="translate(-205 -515)">
        <path
          id="total_winning_svg__prefix__bound"
          fill="none"
          d="M0 0h35v35H0z"
          transform="translate(205 515)"
        />
        <g id="total_winning_svg__prefix__guarantee" transform="translate(181.65 503.918)">
          <path
            id="total_winning_svg__prefix__Path_5248"
            d="M47.656 154.922a2.372 2.372 0 01-.733-.112 3.7 3.7 0 01-1.821-1.672 3.479 3.479 0 00-.6-.757 1.365 1.365 0 00-.309-.15l-2.909 11.812 3.552-1.838 2.293 3.277 2.743-11.135c-.174.051-.365.12-.552.187a4.922 4.922 0 01-1.664.388z"
            className="total_winning_svg__prefix__cls-2"
            data-name="Path 5248"
            transform="translate(-12.746 -120.443)"
          />
          <path
            id="total_winning_svg__prefix__Path_5249"
            d="M110.138 153.138a3.7 3.7 0 01-1.822 1.672 2.369 2.369 0 01-.732.112 4.917 4.917 0 01-1.667-.388 8.194 8.194 0 00-.616-.2l2.827 11.237 2.272-3.371 3.553 1.838-2.909-11.812a1.433 1.433 0 00-.309.15 3.463 3.463 0 00-.597.762z"
            className="total_winning_svg__prefix__cls-2"
            data-name="Path 5249"
            transform="translate(-67.37 -120.443)"
          />
          <path
            id="total_winning_svg__prefix__Path_5250"
            fill="#ff4893"
            d="M49.005 35.283a3.4 3.4 0 01-.523-.781 3.523 3.523 0 01-.046-1 6.916 6.916 0 00-.03-1.19 2.6 2.6 0 00-.457-1.2 3.689 3.689 0 00-2.136-1.207 3.489 3.489 0 01-.918-.344 3.465 3.465 0 01-.6-.757 7.69 7.69 0 00-.645-.868 2.7 2.7 0 00-1.177-.8 2.364 2.364 0 00-.732-.113 4.921 4.921 0 00-1.667.388 3.561 3.561 0 01-.986.269 3.559 3.559 0 01-.985-.269 4.928 4.928 0 00-1.667-.388 2.365 2.365 0 00-.732.113 3.7 3.7 0 00-1.821 1.672 3.448 3.448 0 01-.6.757 3.5 3.5 0 01-.918.344 3.68 3.68 0 00-2.136 1.207 3.673 3.673 0 00-.488 2.391 3.573 3.573 0 01-.045 1 3.461 3.461 0 01-.523.781 3.716 3.716 0 00-1.035 2.27 3.72 3.72 0 001.035 2.27 3.413 3.413 0 01.523.781 3.539 3.539 0 01.046 1A3.672 3.672 0 0030.23 44a3.684 3.684 0 002.138 1.2 3.51 3.51 0 01.918.344 3.472 3.472 0 01.6.757A3.7 3.7 0 0035.7 47.97a2.371 2.371 0 00.733.112 4.924 4.924 0 001.667-.388 3.576 3.576 0 01.985-.268 3.575 3.575 0 01.986.268 4.917 4.917 0 001.667.388 2.368 2.368 0 00.732-.112 3.7 3.7 0 001.83-1.67 3.464 3.464 0 01.6-.757 3.519 3.519 0 01.919-.344 3.692 3.692 0 002.136-1.206 3.677 3.677 0 00.487-2.391 3.516 3.516 0 01.046-.995 3.407 3.407 0 01.523-.783 3.722 3.722 0 001.035-2.27 3.723 3.723 0 00-1.035-2.27z"
            data-name="Path 5250"
            transform="translate(-1.527 -13.603)"
          />
          <path
            id="total_winning_svg__prefix__Path_5251"
            d="M45.1 153.137a3.479 3.479 0 00-.6-.757 1.365 1.365 0 00-.309-.15l-2.909 11.812 2.759-1.428 2.039-8.282a5.559 5.559 0 01-.98-1.195z"
            className="total_winning_svg__prefix__cls-4"
            data-name="Path 5251"
            transform="translate(-12.746 -120.442)"
          />
          <path
            id="total_winning_svg__prefix__Path_5252"
            d="M105.918 166.748c-.212-.076-.424-.152-.616-.2l2.806 11.151 1.781-2.546-1.979-8.039a2.456 2.456 0 01-.325.025 4.921 4.921 0 01-1.667-.388z"
            className="total_winning_svg__prefix__cls-4"
            data-name="Path 5252"
            transform="translate(-67.37 -132.657)"
          />
          <path
            id="total_winning_svg__prefix__Path_5253"
            d="M45.606 164.217a.262.262 0 01-.215-.112l-2.161-3.089-3.348 1.733a.263.263 0 01-.376-.3l2.909-11.812a.262.262 0 01.347-.183 1.547 1.547 0 01.371.184 3.552 3.552 0 01.661.823 3.5 3.5 0 001.684 1.568 2.107 2.107 0 00.652.1 4.712 4.712 0 001.574-.371c.2-.073.392-.141.571-.194a.262.262 0 01.329.315l-2.744 11.138a.262.262 0 01-.207.2.239.239 0 01-.047 0zm-2.293-3.8a.262.262 0 01.215.112l1.961 2.8 2.49-10.11-.093.034a5.133 5.133 0 01-1.756.4 2.63 2.63 0 01-.814-.125 3.914 3.914 0 01-1.958-1.776 4.042 4.042 0 00-.512-.673l-2.692 10.933 3.039-1.572a.261.261 0 01.12-.025z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5253"
            transform="translate(-11.22 -118.916)"
          />
          <path
            id="total_winning_svg__prefix__Path_5254"
            fill="#df2e76"
            d="M43.627 64.191a4.921 4.921 0 01-1.667-.391 3.566 3.566 0 00-.985-.268 3.559 3.559 0 00-.986.268 4.921 4.921 0 01-1.667.388 2.366 2.366 0 01-.732-.113 3.7 3.7 0 01-1.821-1.672 3.5 3.5 0 00-.6-.757 3.5 3.5 0 00-.919-.344 3.687 3.687 0 01-2.134-1.202 3.675 3.675 0 01-.487-2.391 3.528 3.528 0 00-.046-1 3.392 3.392 0 00-.523-.781 3.725 3.725 0 01-1.035-2.271 3.726 3.726 0 011.035-2.27 3.4 3.4 0 00.523-.781 3.513 3.513 0 00.046-.995 3.854 3.854 0 01.414-2.273 3.27 3.27 0 00-1.811 1.111 3.673 3.673 0 00-.488 2.391 3.573 3.573 0 01-.045 1 3.461 3.461 0 01-.523.781 3.716 3.716 0 00-1.035 2.27 3.72 3.72 0 001.035 2.27 3.413 3.413 0 01.523.781 3.539 3.539 0 01.046 1 3.672 3.672 0 00.488 2.391 3.684 3.684 0 002.136 1.206 3.509 3.509 0 01.918.344 3.472 3.472 0 01.6.757 3.7 3.7 0 001.813 1.668 2.371 2.371 0 00.733.112 4.925 4.925 0 001.667-.388 3.576 3.576 0 01.985-.268 3.575 3.575 0 01.986.268 4.917 4.917 0 001.667.388 2.368 2.368 0 00.732-.112 3 3 0 001.447-1.139 2.508 2.508 0 01-.295.022z"
            data-name="Path 5254"
            transform="translate(-1.527 -30.941)"
          />
          <path
            id="total_winning_svg__prefix__Path_5255"
            d="M40.214 46.823a5.12 5.12 0 01-1.756-.4 3.574 3.574 0 00-.9-.252 3.56 3.56 0 00-.9.252 5.133 5.133 0 01-1.756.4 2.63 2.63 0 01-.802-.123 3.914 3.914 0 01-1.958-1.776 3.563 3.563 0 00-.535-.691 3.608 3.608 0 00-.836-.3 3.945 3.945 0 01-2.276-1.3 3.877 3.877 0 01-.538-2.552 3.624 3.624 0 00-.033-.908 3.528 3.528 0 00-.475-.695 3.937 3.937 0 01-1.1-2.438 3.979 3.979 0 011.092-2.44l.011-.013a3.506 3.506 0 00.469-.687 3.643 3.643 0 00.033-.9 3.883 3.883 0 01.538-2.554 3.942 3.942 0 012.277-1.3 3.527 3.527 0 00.835-.3 3.505 3.505 0 00.53-.683 3.968 3.968 0 011.966-1.797 2.628 2.628 0 01.814-.126 5.124 5.124 0 011.752.4 3.567 3.567 0 00.9.255 3.553 3.553 0 00.9-.253 5.13 5.13 0 011.756-.4 2.622 2.622 0 01.813.126 2.944 2.944 0 011.291.879.262.262 0 01-.39.351 2.438 2.438 0 00-1.062-.731 2.1 2.1 0 00-.651-.1 4.709 4.709 0 00-1.574.371 3.687 3.687 0 01-1.079.285 3.666 3.666 0 01-1.075-.284 4.729 4.729 0 00-1.577-.372 2.1 2.1 0 00-.651.1 3.485 3.485 0 00-1.684 1.569 3.471 3.471 0 01-.663.823 3.518 3.518 0 01-1 .383 3.475 3.475 0 00-2 1.109 3.467 3.467 0 00-.438 2.227 3.673 3.673 0 01-.058 1.085 3.392 3.392 0 01-.556.85l-.011.014a3.506 3.506 0 00-.979 2.108 3.512 3.512 0 00.979 2.108 3.441 3.441 0 01.563.857 3.639 3.639 0 01.059 1.085 3.467 3.467 0 00.438 2.227 3.475 3.475 0 002 1.108 3.544 3.544 0 011 .384 3.554 3.554 0 01.662.823 3.5 3.5 0 001.68 1.573 2.108 2.108 0 00.652.1 4.711 4.711 0 001.574-.371 3.693 3.693 0 011.078-.285 3.675 3.675 0 011.072.283 4.726 4.726 0 001.58.373 2.109 2.109 0 00.651-.1 3.5 3.5 0 001.683-1.566 3.5 3.5 0 01.663-.825 3.553 3.553 0 011-.384 3.484 3.484 0 002-1.108 3.472 3.472 0 00.437-2.227A3.618 3.618 0 0146.7 39a3.419 3.419 0 01.565-.861.262.262 0 11.414.322 3.544 3.544 0 00-.48.7 3.523 3.523 0 00-.034.9 3.888 3.888 0 01-.537 2.554 3.9 3.9 0 01-2.276 1.3 3.537 3.537 0 00-.837.3 3.578 3.578 0 00-.533.689 3.916 3.916 0 01-1.955 1.796 2.633 2.633 0 01-.813.123z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5255"
            transform="translate(0 -12.081)"
          />
          <path
            id="total_winning_svg__prefix__Path_5256"
            fill="#eee"
            d="M72.954 62.781a6.191 6.191 0 11-1.361-3.875 6.193 6.193 0 011.361 3.875z"
            data-name="Path 5256"
            transform="translate(-29.198 -38.831)"
          />
          <path
            id="total_winning_svg__prefix__Path_5257"
            fill="#e8c205"
            d="M83.436 74.149l1.056 2.139 2.361.343-1.71 1.669.4 2.351-2.111-1.11-2.111 1.11.4-2.351-1.708-1.666 2.361-.343z"
            data-name="Path 5257"
            transform="translate(-45.796 -53.815)"
          />
          <path
            id="total_winning_svg__prefix__Path_5258"
            d="M90.139 113.911l-1.218.641v.025l1.244-.654z"
            className="total_winning_svg__prefix__cls-9"
            data-name="Path 5258"
            transform="translate(-53.389 -87.745)"
          />
          <path
            id="total_winning_svg__prefix__Path_5259"
            d="M103.5 76.631l-2.361-.343-1.056-2.139-.555 1.124.722 1.461 2.36.342-1.71 1.665.231 1.349 1.061.558-.4-2.351z"
            className="total_winning_svg__prefix__cls-9"
            data-name="Path 5259"
            transform="translate(-62.441 -53.815)"
          />
          <g
            id="total_winning_svg__prefix__Group_2338"
            data-name="Group 2338"
            transform="translate(31.107 17.495)"
          >
            <path
              id="total_winning_svg__prefix__Path_5260"
              d="M79.8 79.383a.262.262 0 01-.259-.307l.379-2.215-1.609-1.569a.262.262 0 01.146-.448l2.224-.323.994-2.015a.262.262 0 01.471 0l.995 2.015 2.224.323a.262.262 0 01.145.448l-1.61 1.569.38 2.215a.262.262 0 01-.381.277l-1.989-1.046-1.99 1.046a.258.258 0 01-.122.03zm-.741-4.1l1.327 1.294a.262.262 0 01.075.232l-.313 1.827 1.641-.863a.263.263 0 01.244 0l1.641.863-.314-1.827a.262.262 0 01.076-.232l1.328-1.294-1.834-.266a.263.263 0 01-.2-.144l-.82-1.662-.82 1.662a.263.263 0 01-.2.144z"
              className="total_winning_svg__prefix__cls-5"
              data-name="Path 5260"
              transform="translate(-75.377 -69.784)"
            />
            <path
              id="total_winning_svg__prefix__Path_5261"
              d="M65.234 67.71a6.455 6.455 0 010-12.911.262.262 0 010 .525 5.931 5.931 0 104.575 9.705.262.262 0 01.4.334 6.44 6.44 0 01-4.979 2.346z"
              className="total_winning_svg__prefix__cls-5"
              data-name="Path 5261"
              transform="translate(-58.779 -54.799)"
            />
            <path
              id="total_winning_svg__prefix__Path_5262"
              d="M64.878 169.819a.263.263 0 01-.255-.325l1.114-4.524a.262.262 0 11.51.125l-1.114 4.524a.263.263 0 01-.255.2z"
              className="total_winning_svg__prefix__cls-5"
              data-name="Path 5262"
              transform="translate(-63.759 -148.638)"
            />
            <path
              id="total_winning_svg__prefix__Path_5263"
              d="M122.654 173.695a.262.262 0 01-.255-.2l-1.1-4.548a.262.262 0 11.51-.124l1.1 4.548a.263.263 0 01-.255.324z"
              className="total_winning_svg__prefix__cls-5"
              data-name="Path 5263"
              transform="translate(-112.119 -151.925)"
            />
            <path
              id="total_winning_svg__prefix__Path_5264"
              d="M106.6 164.3a.262.262 0 01-.255-.2l-2.827-11.237a.263.263 0 01.327-.316c.231.066.5.159.633.209a4.717 4.717 0 001.577.372 2.11 2.11 0 00.651-.1 3.5 3.5 0 001.683-1.566l.22.144-.218-.147a3.49 3.49 0 01.66-.822 1.623 1.623 0 01.37-.183.263.263 0 01.349.182l2.909 11.812a.263.263 0 01-.376.3l-3.346-1.731-2.141 3.17a.262.262 0 01-.216.113zm-2.456-11.1l2.568 10.209 1.943-2.877a.262.262 0 01.338-.086l3.04 1.573-2.693-10.933a4.025 4.025 0 00-.511.672l-.218-.146.216.149a3.909 3.909 0 01-1.957 1.773 2.633 2.633 0 01-.813.125 5.12 5.12 0 01-1.756-.4z"
              className="total_winning_svg__prefix__cls-5"
              data-name="Path 5264"
              transform="translate(-96.95 -136.409)"
            />
          </g>
          <path
            id="total_winning_svg__prefix__Path_5265"
            fill="#f9b28a"
            d="M139.447 18.551h-1.424a3.236 3.236 0 00-1.805-1.073 6.014 6.014 0 01-2.7-2.217l-.193-.319a3.461 3.461 0 01-.188-.339l-.485-1.113a1.051 1.051 0 00-2.015.459 2.483 2.483 0 00.011.381 5.607 5.607 0 001.062 3.083h-2.31a1.074 1.074 0 00-.261 2.116l-.03.08a1.07 1.07 0 00-.175 2v.22a1.07 1.07 0 00.324 2.027c.027.056.054.113.084.168a.905.905 0 00.491 1.667h5.721a3.224 3.224 0 002.078-.756h1.811v-6.384z"
            data-name="Path 5265"
            transform="translate(-87.017 -1.512)"
          />
          <path
            id="total_winning_svg__prefix__Path_5266"
            d="M145.127 17.419h.907a5.611 5.611 0 01-1.062-3.083 2.578 2.578 0 01-.011-.381 1.052 1.052 0 01.594-.986 1.046 1.046 0 00-1.5.986 2.483 2.483 0 00.011.381 5.6 5.6 0 001.061 3.083z"
            className="total_winning_svg__prefix__cls-11"
            data-name="Path 5266"
            transform="translate(-100.435 -1.521)"
          />
          <path
            id="total_winning_svg__prefix__Path_5267"
            d="M129.837 51.278a.9.9 0 01.415-.76c-.03-.055-.057-.112-.084-.168a1.07 1.07 0 01-.324-2.027V48.1a1.07 1.07 0 01.174-2l.03-.08a1.074 1.074 0 01.262-2.116h-.91a1.074 1.074 0 00-.261 2.116l-.03.08a1.07 1.07 0 00-.175 2v.22a1.07 1.07 0 00.324 2.027c.027.056.054.113.084.168a.905.905 0 00.491 1.667h.906a.907.907 0 01-.906-.907z"
            className="total_winning_svg__prefix__cls-11"
            data-name="Path 5267"
            transform="translate(-87.017 -28.011)"
          />
          <path
            id="total_winning_svg__prefix__Path_5268"
            fill="#14a2ff"
            d="M204.127 51.688h3.482v6.379h-3.482z"
            data-name="Path 5268"
            transform="translate(-151.698 -34.649)"
          />
          <path
            id="total_winning_svg__prefix__Path_5269"
            fill="#098dd6"
            d="M204.127 79.939h3.482v2.234h-3.482z"
            data-name="Path 5269"
            transform="translate(-151.698 -58.756)"
          />
          <path
            id="total_winning_svg__prefix__Path_5270"
            d="M134.033 24.436h-5.72a1.168 1.168 0 01-.9-1.911 1.34 1.34 0 01-.869-1.249 1.322 1.322 0 01.547-1.076 1.322 1.322 0 01-.547-1.075 1.338 1.338 0 01.548-1.075 1.336 1.336 0 01.79-2.415h1.782a6.345 6.345 0 01-.8-2.8 2.792 2.792 0 01-.011-.4 1.306 1.306 0 01.788-1.242 1.289 1.289 0 01.27-.083.394.394 0 01.051-.007 1.366 1.366 0 01.229-.017h.038a1.247 1.247 0 01.24.034l.019.005a1.35 1.35 0 01.239.086 1.316 1.316 0 01.645.66l.485 1.113c.008.019.038.081.165.3a.241.241 0 01.016.027c.049.081.113.188.184.3a5.717 5.717 0 002.552 2.1 3.516 3.516 0 011.846 1.063h1.305a.262.262 0 01.262.262v6.379a.262.262 0 01-.262.262H136.2a3.5 3.5 0 01-2.167.759zm-6.155-8.276a.811.811 0 00-.2 1.6.263.263 0 01.181.349l-.026.071a.262.262 0 01-.177.168.815.815 0 00-.594.779.806.806 0 00.462.729.262.262 0 01.148.236v.22a.263.263 0 01-.148.236.806.806 0 00-.462.729.814.814 0 00.707.8.263.263 0 01.2.146l.017.034c.019.04.038.08.06.119a.263.263 0 01-.086.349.643.643 0 00.349 1.184h5.72a2.978 2.978 0 001.91-.694.262.262 0 01.169-.061h1.548V17.3H136.5a.262.262 0 01-.2-.092 2.99 2.99 0 00-1.659-.987.252.252 0 01-.046-.014 6.253 6.253 0 01-2.818-2.316l-.194-.32-.008-.012a3.6 3.6 0 01-.2-.37l-.484-1.111a.781.781 0 00-.387-.395.82.82 0 00-.153-.055h-.015a.776.776 0 00-.137-.018h-.031a.888.888 0 00-.127.012h-.034a.773.773 0 00-.156.048.785.785 0 00-.473.754v.024a2.25 2.25 0 00.01.341v.017a5.375 5.375 0 00.995 2.916.263.263 0 01-.195.438zm2.136-4.541h-.008z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5270"
            transform="translate(-85.493)"
          />
          <path
            id="total_winning_svg__prefix__Path_5271"
            d="M206.083 56.8H202.6a.262.262 0 01-.262-.262v-6.377a.262.262 0 01.262-.262h3.482a.262.262 0 01.262.262v6.379a.262.262 0 01-.261.26zm-3.219-.525h2.957v-5.851h-2.957z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5271"
            transform="translate(-150.172 -33.123)"
          />
          <path
            id="total_winning_svg__prefix__Path_5272"
            d="M133.058 57.615h-.906a.262.262 0 010-.525h.906a.262.262 0 110 .525z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5272"
            transform="translate(-90.057 -39.259)"
          />
          <path
            id="total_winning_svg__prefix__Path_5273"
            d="M131.862 72.163h-.907a.262.262 0 010-.525h.907a.262.262 0 010 .525z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5273"
            transform="translate(-89.036 -51.673)"
          />
          <path
            id="total_winning_svg__prefix__Path_5274"
            d="M134.535 87.309h-.906a.262.262 0 110-.525h.906a.262.262 0 010 .525z"
            className="total_winning_svg__prefix__cls-5"
            data-name="Path 5274"
            transform="translate(-91.317 -64.597)"
          />
        </g>
      </g>
    </svg>
  );
}

export default SvgTotalWinning;
